import {Component, DestroyRef, inject, OnInit} from '@angular/core';
import {takeUntilDestroyed} from '@angular/core/rxjs-interop';
import {EMPTY, timer} from 'rxjs';
import {catchError, exhaustMap} from 'rxjs/operators';
import {CardCheduledComponent} from './card-cheduled/card-cheduled.component';
import {CardJobComponent} from './card-job/card-job.component';
import {environment} from '../../../environments/environment';
import {RotinaProgramadaModel} from '../shared/model/rotina-programada/rotina-programada-model';
import {RotinaProgramadasService} from '../shared/service/rotina-programadas.service';
import {TituloRotinaComponent} from '../shared/components/app-titulo/titulo-component';

const INTERVALO_ATUALIZACAO_TAREFAS_MS = 1000;

@Component({
  selector: 'app-jobs-scheduled',
  standalone: true,
  imports: [
    CardCheduledComponent,
    CardJobComponent,
    TituloRotinaComponent
  ],
  templateUrl: './jobs-scheduled.component.html',
  styleUrl: './jobs-scheduled.component.css'
})
export class JobsScheduledComponent implements OnInit {

  scheduled: string = environment.urlScheduleHealth;
  tarefas: RotinaProgramadaModel[] = [];


  private readonly rotinaProgramadaService = inject(RotinaProgramadasService);
  private readonly destroyRef = inject(DestroyRef);

  ngOnInit() {
    timer(0, INTERVALO_ATUALIZACAO_TAREFAS_MS).pipe(
      exhaustMap(() => this.rotinaProgramadaService.buscarTodos(true).pipe(catchError(() => EMPTY))),
      takeUntilDestroyed(this.destroyRef)
    ).subscribe(tarefas => this.tarefas = tarefas);
  }


}
